import agendraLogo from "@/assets/agendra-logo.webp";
import alexisAvatar from "@/assets/alexis-agendra-founder.webp";
import {
  Attribution,
  QuoteCard,
  useInViewRef,
} from "@/components/sections/testimonial/shared";

export function Step6Testimonial() {
  const { ref } = useInViewRef<HTMLElement>();

  return (
    <section ref={ref} className="flex flex-col">
      <h2 className="text-3xl font-bold tracking-tight text-foreground">
        Mockup in my inbox in under{" "}
        <span className="text-gradient-cycle font-bold">12 hours.</span>
      </h2>

      <QuoteCard>
        I filled out the form at night and woke up to a full mockup of my site.
        I wasn't expecting it to{" "}
        <span className="text-gradient-cycle font-bold">
          actually look that good.
        </span>
      </QuoteCard>

      <Attribution
        avatarSrc={alexisAvatar}
        avatarAlt="Alexis Baggett"
        name="Alexis Baggett"
        role="Founder, Agendra"
        logoSrc={agendraLogo}
        logoAlt="Agendra logo"
      />
    </section>
  );
}
